<div class="home9-theme">
  <app-banner2></app-banner2>
  <app-services-section></app-services-section>
  <app-address-section></app-address-section>
</div>
